import React, { useEffect, useState } from "react";
import { Loading } from "seed/helpers";
import l from "components/util/l";

const RulesView = ({
  isLoading = false,
  isSaving = false,
  nodeId,
  nodeRules = [],
  projectRules = [],
  onClose = () => { },
  onSaveNodeRules = () => { },
  onSaveProjectRules = () => { },
}) => (
  <div className="chat-history-panel animate__animated animate__fadeIn animate__faster">

    {/* Header */}
    <div className="chat-history-panel-header d-flex align-items-center">
      <i className="fas fa-sliders mr-2" />
      <span className="text-truncate">{l("Reglas%PA102")}</span>
      <button
        type="button"
        className="chat-history-panel-close ml-auto"
        title={l("Cerrar%GA089")}
        onClick={onClose}>
        <i className="fas fa-times" />
      </button>
    </div>

    {/* This project's rules always apply; this agent's are an extra, narrower layer on top */}
    <div className="chat-history-panel-body">

      {isLoading && <Loading />}

      {!isLoading &&
        <RulesSection
          isSaving={isSaving}
          label={l("Este proyecto%CH042")}
          rules={projectRules}
          onSave={onSaveProjectRules}
        />}

      {!isLoading && nodeId &&
        <RulesSection
          isSaving={isSaving}
          label={l("Este agente%CH038")}
          rules={nodeRules}
          onSave={onSaveNodeRules}
        />}

    </div>

  </div>
);

// Every add, edit and delete stays local until Save commits the whole list at once —
// nothing above needs to know about the list mid-edit.
const RulesSection = ({
  isSaving = false,
  label,
  rules = [],
  onSave = () => { },
}) => {

  const [draftRules, setDraftRules] = useState(rules);
  const [isDirty, setIsDirty] = useState(false);

  useEffect(() => {
    if (!isDirty) setDraftRules(rules);
  }, [rules]); // eslint-disable-line react-hooks/exhaustive-deps

  const onChangeRule = (index, text) => {
    const updated = [...draftRules];
    updated[index] = text;
    setDraftRules(updated);
    setIsDirty(true);
  };

  const onClickAddRule = () => {
    setDraftRules([...draftRules, ""]);
    setIsDirty(true);
  };

  const onClickDeleteRule = (index) => {
    setDraftRules(draftRules.filter((_, ruleIndex) => ruleIndex != index));
    setIsDirty(true);
  };

  const onClickSave = () => {
    onSave(draftRules.map(rule => rule.trim()).filter(rule => rule != ""));
    setIsDirty(false);
  };

  return (
    <div className="chat-rules-panel-section">
      <div className="chat-rules-panel-section-label">{label}</div>

      {draftRules.map((rule, index) =>
        <div className="chat-rules-panel-item" key={index}>
          <input
            type="text"
            className="chat-rules-panel-item-input"
            value={rule}
            placeholder={l("Escribe una regla%CH040")}
            onChange={(event) => onChangeRule(index, event.target.value)}
          />
          <button
            type="button"
            className="chat-rules-panel-item-delete"
            title={l("Eliminar%GA001")}
            onClick={() => onClickDeleteRule(index)}>
            <i className="fas fa-times" />
          </button>
        </div>)}

      <button type="button" className="chat-rules-panel-add" onClick={onClickAddRule}>
        <i className="fas fa-plus mr-1" />
        {l("Agregar regla%CH041")}
      </button>

      {isDirty &&
        <button
          type="button"
          className="chat-rules-panel-save"
          disabled={isSaving}
          onClick={onClickSave}>
          {isSaving && <i className="fas fa-spinner fa-pulse mr-2" />}
          {!isSaving && <i className="fas fa-check mr-2" />}
          {l("Guardar%GA023")}
        </button>}

    </div>
  );
};

export default RulesView;
